
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e6f3a6ea&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./recentdisbursment.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./recentdisbursment.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-e6f3a6ea!../../node_modules/vue-loader/lib/selector?type=template&index=0!./recentdisbursment.vue"),
  /* scopeId */
  "data-v-e6f3a6ea",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/dashboard/recentdisbursment.vue
// module id = 679
// module chunks = 0